var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "modalContainer", staticClass: "_modal-container" }, [
    _c(
      "div",
      {
        class: ["modal", _vm.className, _vm.modalType],
        attrs: { "data-reveal": "" },
      },
      [
        _vm.showCloseBtn
          ? _c("span", { staticClass: "close-btn", on: { click: _vm.close } }, [
              _vm._v("×"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default"),
        _vm._v(" "),
        _vm._t("modal-header"),
        _vm._v(" "),
        _vm._t("content"),
        _vm._v(" "),
        _vm.showBtns
          ? _c("div", { staticClass: "modal-btns" }, [_vm._t("btns")], 2)
          : _vm._e(),
        _vm._v(" "),
        _vm._t("bottom-content"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }